import {useStreamEffect, useTimeoutCallback} from '../../utils';
import {useCallback, useEffect, useId, useState} from 'react';
import {SnackbarMessage} from '../message';
import {SnackbarManager, MessageOptions} from '../snackbar/snackbar';

export function SnackbarLayout() {
	const id = useId();

	const [isActive, setIsActive] = useState(false);
	const [nextMessage, setNextMessage] = useState<MessageOptions>();
	const [currentMessage, setCurrentMessage] = useState<MessageOptions>();
	const [messageExpired, setMessageExpired] = useState(false);
	const [startMessageExpiring, cancelMessageExpiring] = useTimeoutCallback(() => setMessageExpired(true));

	useEffect(() => {
		SnackbarManager.setLayout(id);
		return () => SnackbarManager.disposeLayout(id);
	}, [id]);

	useEffect(() => {
		if (currentMessage) {
			setMessageExpired(false);
			startMessageExpiring(currentMessage.timeToLive);
			setNextMessage(undefined);
		}
	}, [currentMessage, startMessageExpiring]);

	const afterMessageDeleted = useCallback(() => {
		setMessageExpired(false);
		setCurrentMessage(nextMessage);
	}, [nextMessage]);

	useStreamEffect(SnackbarManager.activeLayout, (layout) => {
		setIsActive(layout === id);
	});

	useStreamEffect(SnackbarManager.onClear, () => {
		cancelMessageExpiring();
		setCurrentMessage(undefined);
	});

	useStreamEffect(SnackbarManager.onMessage, (message) => {
		if (!isActive) {
			return;
		}

		if (currentMessage) {
			cancelMessageExpiring();
			setMessageExpired(true);
			setNextMessage(message);
		} else {
			setCurrentMessage(message);
		}
	});

	if (!currentMessage) {
		return;
	}

	const {vPos, offsetX, hPos, offsetY, message} = currentMessage;

	return <SnackbarMessage
		vPos={offsetY || vPos}
		hPos={offsetX || hPos}
		show={!messageExpired}
		animationDuration={300}
		onExit={afterMessageDeleted}
		message={message}/>;

}
